import { Injectable, ApplicationRef, NgZone } from '@angular/core';
import { WebStorageService } from './web-storage-service.class';

@Injectable()
export class LocalStorageService extends WebStorageService {
    constructor(protected _aref: ApplicationRef, protected _zone: NgZone) {
        super(localStorage, _aref, _zone);
    }
}
